module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('header', {
    staticClass: "text-white pt-4 pb-12 px-4 flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-2"
  }, [_c('a', {
    attrs: {
      "id": "install_infos_btn_back",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-arrow-left bg-white"
  })]), _vm._v(" "), _c('span', [_vm._v("Informations complémentaires")])]), _vm._v(" "), (_vm.installation.batiment) ? _c('div', {
    staticClass: "hidden md:block"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "opacity-90"
  }, [_vm._v("Bâtiment :")]), _vm._v(" "), _c('span', {
    staticClass: "text-white font-bold ml-1"
  }, [_vm._v(_vm._s(_vm.installation.batiment.nom))])])]) : _vm._e()])]), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-lg overflow-hidden mb-30"
  }, [_c('div', {
    staticClass: "bg-white p-4"
  }, [(_vm.installation.batiment) ? _c('div', {
    staticClass: "md:hidden text-right mb-2"
  }, [_c('span', [_vm._v("Bâtiment: ")]), _vm._v(" "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.installation.batiment.nom))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "space-y-4",
    attrs: {
      "method": "post",
      "id": "installation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm()
      },
      "input": _vm.updateForm
    }
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "date_mise_en_service"
    }
  }, [_vm._v("Date mise en service "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.date_mise_en_service),
      expression: "newInformation.date_mise_en_service"
    }],
    staticClass: "input",
    attrs: {
      "id": "date_mise_en_service",
      "type": "date",
      "max": _vm.today
    },
    domProps: {
      "value": (_vm.newInformation.date_mise_en_service)
    },
    on: {
      "change": function($event) {
        return _vm.updateEntretienDate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation, "date_mise_en_service", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-2 mb-5"
  }, [_c('div', {
    staticClass: "mb-2 p-4"
  }, [_c('h3', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("DESP")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Équipement soumis à la DESP ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.desp.is_checked),
      expression: "newInformation.desp.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "desp_is_checked"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.newInformation.desp.is_checked, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.newInformation.desp, "is_checked", true)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Oui\n                                    ")])]), _vm._v(" "), _c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.desp.is_checked),
      expression: "newInformation.desp.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "desp_is_checked"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.newInformation.desp.is_checked, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.newInformation.desp, "is_checked", false)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Non\n                                    ")])])]), _vm._v(" "), (_vm.newInformation.desp.is_checked === true) ? _c('div', {
    staticClass: "space-y-4 mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "desp_last_date"
    }
  }, [_vm._v("Inspection périodique réalisée\n                                        le")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.desp.last_date),
      expression: "newInformation.desp.last_date"
    }],
    staticClass: "input",
    attrs: {
      "id": "desp_last_date",
      "type": "date",
      "max": _vm.today
    },
    domProps: {
      "value": (_vm.newInformation.desp.last_date)
    },
    on: {
      "change": function($event) {
        return _vm.setDespLastDate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.desp, "last_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "desp_alarm"
    }
  }, [_vm._v("Alarme")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.desp.alarm),
      expression: "newInformation.desp.alarm"
    }],
    staticClass: "input",
    attrs: {
      "id": "desp_alarm"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newInformation.desp, "alarm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Aucune")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("48 mois")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "desp_commentaire"
    }
  }, [_vm._v("Commentaire")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.desp.commentaire),
      expression: "newInformation.desp.commentaire"
    }],
    staticClass: "input",
    attrs: {
      "id": "desp_commentaire"
    },
    domProps: {
      "value": (_vm.newInformation.desp.commentaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.desp, "commentaire", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', [_c('button', {
    staticClass: "bg-secondary text-white px-3 py-2 rounded flex items-center gap-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.photoDESP.click()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-photo bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Photographier le document")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "photoDESP",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handlePhotoInstallDESP
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newInformation.desp.file !== null),
      expression: "newInformation.desp.file !== null"
    }],
    staticClass: "mt-4 flex justify-center"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "icon icon-delete absolute -top-2 -right-2 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.newInformation.desp.file = null
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.newInformation.desp.file,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.newInformation.desp.file,
      "alt": "photo installation"
    }
  })])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 p-4"
  }, [_c('h3', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("\n                                Maintenance Préventive\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Équipement soumis à une maintenance préventive ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.maintenance.is_checked),
      expression: "newInformation.maintenance.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "maintenance_is_checked"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.newInformation.maintenance.is_checked, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.newInformation.maintenance, "is_checked", true)
      }, _vm.updateMaintenance]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors\n                                peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Oui\n                                    ")])]), _vm._v(" "), _c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.maintenance.is_checked),
      expression: "newInformation.maintenance.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "maintenance_is_checked"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.newInformation.maintenance.is_checked, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.newInformation.maintenance, "is_checked", false)
      }, _vm.updateMaintenance]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors\n                                peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Non\n                                    ")])])]), _vm._v(" "), (_vm.newInformation.maintenance.is_checked === true) ? _c('div', {
    staticClass: "space-y-4 mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "maintenance_last_date"
    }
  }, [_vm._v("\n                                        Maintenance préventive réalisée le\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.maintenance.last_date),
      expression: "newInformation.maintenance.last_date"
    }],
    staticClass: "input",
    attrs: {
      "id": "maintenance_last_date",
      "type": "date",
      "max": _vm.today
    },
    domProps: {
      "value": (_vm.newInformation.maintenance.last_date)
    },
    on: {
      "change": function($event) {
        return _vm.setMaintenanceLastDate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.maintenance, "last_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "maintenance_alarm"
    }
  }, [_vm._v("Alarme")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.maintenance.alarm),
      expression: "newInformation.maintenance.alarm"
    }],
    staticClass: "input",
    attrs: {
      "id": "maintenance_alarm"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newInformation.maintenance, "alarm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Aucune")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24 mois")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "maintenance_commentaire"
    }
  }, [_vm._v("Commentaire")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.maintenance.commentaire),
      expression: "newInformation.maintenance.commentaire"
    }],
    staticClass: "input",
    attrs: {
      "id": "maintenance_commentaire"
    },
    domProps: {
      "value": (_vm.newInformation.maintenance.commentaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.maintenance, "commentaire", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', [_c('button', {
    staticClass: "bg-secondary text-white px-3 py-2 rounded flex items-center gap-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.photoMaintenance.click()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-photo bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Photographier le document")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "photoMaintenance",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handlePhotoInstallMaintenance
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newInformation.maintenance.file !== null),
      expression: "newInformation.maintenance.file !== null"
    }],
    staticClass: "mt-4 flex justify-center"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "icon icon-delete absolute -top-2 -right-2 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.newInformation.maintenance.file = null
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.newInformation.maintenance.file,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.newInformation.maintenance.file,
      "alt": "photo installation"
    }
  })])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 p-4"
  }, [_c('h3', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("\n                                Entretien\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v("Équipement soumis à l'attestation d'entretien 4kW à 70 kW ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.is_checked),
      expression: "newInformation.attestation.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "attestation_is_checked"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.newInformation.attestation.is_checked, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.newInformation.attestation, "is_checked", true)
      }, _vm.updateAttestation]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors\n     peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Oui\n                                    ")])]), _vm._v(" "), _c('label', {
    staticClass: "inline-flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.is_checked),
      expression: "newInformation.attestation.is_checked"
    }],
    staticClass: "hidden peer",
    attrs: {
      "type": "radio",
      "name": "attestation_is_checked"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.newInformation.attestation.is_checked, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.newInformation.attestation, "is_checked", false)
      }, _vm.updateAttestation]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors\n     peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("\n                                        Non\n                                    ")])])]), _vm._v(" "), (_vm.newInformation.attestation.is_checked === true) ? _c('div', {
    staticClass: "space-y-4 mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "attestation_last_date"
    }
  }, [_vm._v("Date de l'attestation\n                                        d'entretien")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.last_date),
      expression: "newInformation.attestation.last_date"
    }],
    staticClass: "input",
    attrs: {
      "id": "attestation_last_date",
      "type": "date"
    },
    domProps: {
      "value": (_vm.newInformation.attestation.last_date)
    },
    on: {
      "change": function($event) {
        return _vm.setAttestionLastDate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.attestation, "last_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "type_equipement"
    }
  }, [_vm._v("Type d'équipement")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.type_equipement),
      expression: "newInformation.attestation.type_equipement"
    }],
    staticClass: "input",
    attrs: {
      "id": "type_equipement"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newInformation.attestation, "type_equipement", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listTypeEquipement), function(type) {
    return _c('option', {
      key: type,
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-2"
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "puissance_chaud"
    }
  }, [_vm._v("Puissance chaud (kW)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.puissance_chaud),
      expression: "newInformation.attestation.puissance_chaud"
    }],
    staticClass: "input",
    attrs: {
      "id": "puissance_chaud",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newInformation.attestation.puissance_chaud)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.attestation, "puissance_chaud", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "puissance_froid"
    }
  }, [_vm._v("Puissance froid (kW)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.puissance_froid),
      expression: "newInformation.attestation.puissance_froid"
    }],
    staticClass: "input",
    attrs: {
      "id": "puissance_froid",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newInformation.attestation.puissance_froid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.attestation, "puissance_froid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "attestation_commentaire"
    }
  }, [_vm._v("Commentaire")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInformation.attestation.commentaire),
      expression: "newInformation.attestation.commentaire"
    }],
    staticClass: "input",
    attrs: {
      "id": "attestation_commentaire"
    },
    domProps: {
      "value": (_vm.newInformation.attestation.commentaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInformation.attestation, "commentaire", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', [_c('button', {
    staticClass: "bg-secondary text-white px-3 py-2 rounded flex items-center gap-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.photoEntretien.click()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-photo bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Photographier le document")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "photoEntretien",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handlePhotoInstallEntretien
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newInformation.attestation.file !== null),
      expression: "newInformation.attestation.file !== null"
    }],
    staticClass: "mt-4 flex justify-center"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "icon icon-delete absolute -top-2 -right-2 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.newInformation.attestation.file = null
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.newInformation.attestation.file,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.newInformation.attestation.file,
      "alt": "photo attestation d'entretien"
    }
  })])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.canEditInstallations) ? _c('input', {
    staticClass: "btn-primary",
    attrs: {
      "type": "submit",
      "id": "install_infos_btn_save",
      "value": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("Dernière saisie :")]), _vm._v(" "), (_vm.lastInformation != null && _vm.lastInformation.desp.is_checked === true && _vm.installation.fluide !== null) ? _c('div', {
    staticClass: "grid grid-cols-1 gap-2 mb-5"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 font-bold"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-check-circle bg-secondary"
  }), _vm._v("\n                            Équipement soumis à la DESP\n                        ")]), _vm._v(" "), _c('div', [_vm._v("\n                            Dernière inspection le :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.lastInformation.desp.last_date)))])]), _vm._v(" "), _c('div', [_vm._v("\n                            Alarme :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.desp.alarm == 0 ? 'Aucune' :
    _vm.lastInformation.desp.alarm + ' mois'))])]), _vm._v(" "), _c('div', [_vm._v("\n                            Commentaire :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.desp.commentaire))])]), _vm._v(" "), _c('div', [(_vm.lastInformation.desp.file != null && _vm.isBase64(_vm.lastInformation.desp.file) === false) ? _c('a', {
    staticClass: "bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2",
    attrs: {
      "href": ((_vm.Config.urlAdmin) + "/upload/" + (_vm.lastInformation.desp.file)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-eye bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Voir le document")])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation.desp.file != null && _vm.isBase64(_vm.lastInformation.desp.file) === true) ? _c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.lastInformation.desp.file,
      "alt": "photo installation"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastInformation.desp.file === null) ? _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v("Pas de\n                                document")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation != null && _vm.lastInformation.maintenance.is_checked === true) ? _c('div', {
    staticClass: "grid grid-cols-1 gap-2 mb-5"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 font-bold"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-check-circle bg-secondary"
  }), _vm._v("\n                            Équipement soumis à la Maintenance Préventive\n                        ")]), _vm._v(" "), _c('div', [_vm._v("\n                            Maintenance préventive le :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.lastInformation.maintenance.last_date)))])]), _vm._v(" "), _c('div', [_vm._v("\n                            Alarme :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.maintenance.alarm == 0 ?
    'Aucune' : _vm.lastInformation.maintenance.alarm + ' mois'))])]), _vm._v(" "), _c('div', [_vm._v("\n                            Commentaire :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.maintenance.commentaire))])]), _vm._v(" "), _c('div', [(_vm.lastInformation.maintenance.file != null && _vm.isBase64(_vm.lastInformation.maintenance.file) === false) ? _c('a', {
    staticClass: "bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2",
    attrs: {
      "href": ((_vm.Config.urlAdmin) + "/upload/" + (_vm.lastInformation.maintenance.file)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-eye bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Voir le document")])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation.maintenance.file != null && _vm.isBase64(_vm.lastInformation.maintenance.file) === true) ? _c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.lastInformation.maintenance.file,
      "alt": "photo installation"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastInformation.maintenance.file === null) ? _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v("Pas de document")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation != null && _vm.lastInformation.attestation.is_checked === true && _vm.installation.fluide !== null) ? _c('div', {
    staticClass: "grid grid-cols-1 gap-2 mb-5"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 font-bold"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-check-circle bg-secondary"
  }), _vm._v("\n                            Équipement soumis à l'attestation d'entretien\n                        ")]), _vm._v(" "), _c('div', [_vm._v("\n                            Attestation d'entretien le :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.lastInformation.attestation.last_date)))])]), _vm._v(" "), _c('div', [_vm._v("\n                            Type :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.attestation.type_equipement))])]), _vm._v(" "), (_vm.lastInformation.attestation.puissance_chaud) ? _c('div', [_vm._v("\n                            Puissance chaud :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.attestation.puissance_chaud) + "\n                                kW")])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation.attestation.puissance_froid) ? _c('div', [_vm._v("\n                            Puissance froid :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.attestation.puissance_froid) + "\n                                kW")])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                            Commentaire :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v(_vm._s(_vm.lastInformation.attestation.commentaire))])]), _vm._v(" "), _c('div', [(_vm.lastInformation.attestation.file != null && _vm.isBase64(_vm.lastInformation.attestation.file) === false) ? _c('a', {
    staticClass: "bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2",
    attrs: {
      "href": ((_vm.Config.urlAdmin) + "/upload/" + (_vm.lastInformation.attestation.file)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-eye bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Voir le document")])]) : _vm._e(), _vm._v(" "), (_vm.lastInformation.attestation.file != null && _vm.isBase64(_vm.lastInformation.attestation.file) === true) ? _c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.lastInformation.attestation.file,
      "alt": "photo attestation d'entretien"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastInformation.attestation.file === null) ? _c('span', {
    staticClass: "text-secondary font-bold"
  }, [_vm._v("Pas de document")]) : _vm._e()])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7816f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/InformationInstallation.vue
// module id = 1015
// module chunks = 0